import {
  ChangeDetectionStrategy,
  Component,
  input
} from "@angular/core";
import { ImageResolverPipe } from "../../../pipes/sharedpipes/image-resolver.pipe";

@Component({
  selector: "app-promo-card",
  templateUrl: "./promo-card.component.html",
  styleUrls: ["./promo-card.component.scss"],
  imports: [ImageResolverPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PromoCardComponent {
  imageUrl = input.required<string>();
  title = input.required<string>();
  linkText = input.required<string>();
  linkUrl = input.required<string>();

  body = input<string>();
}
